import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { UserState } from '../../../store/reducers/userReducer';
import { RootState } from '../../../store/index';
import Layout from '../../../components/Layout/Layout';
import PPInputFile from '../../../components/Form/PPInputFile';
import LcLoading from '../../../components/Generic/LcLoading';
import LCDashboard from '../../../components/Data/Dashboard/LCDashboard';

import styles from './index.module.css';
import PivotTableWebix from '../../../components/webix';
import { techEAEASService } from '../../../services/techEAEASService';
import Papa from "papaparse";
import SideModal from '../../../components/Layout/SideModal/SideModal';
import {PPInput } from 'processor-plataform-ui';
import { useSnackbar } from 'notistack';
import PPDropDown from '../../../components/PPDropDown';

const PositionsTable: React.FC = (props) => {
    const { enqueueSnackbar } = useSnackbar();
   
    const service = new techEAEASService(props);
    const user = useSelector<RootState, UserState>(state => state.user);
    const tableHeaders = ["De", "Para"];
    const tableFields = [
        { id: tableHeaders[0], value: tableHeaders[0], type: "text" },
        { id: tableHeaders[1], value: tableHeaders[1], type: "text" }
    ];
    const tableFilters = [{ name: tableHeaders[0] }, { name: tableHeaders[1] }];
    const tableStructure = { rows: tableHeaders, columns: [], values: [], filters: tableFilters };
    const [csvFile, setCSVFile] = useState<string>("");
    const [pivotTableData, setPivotTableData] = useState<any[]>([]);
    const [csvValidation, setCSVValidation] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [hasErrors, setHasErrors] = useState<boolean>(false);
    const [showSidePanel, setShowSidePanel] = useState<boolean>(false);
 
    const handleChangeFile = (e) => {
        if (e && e.length > 0) {
            let raw = e[0].body.split(",")[1];
            let parsedData = handleCSVParsing(raw);
            handleCSVValidation(parsedData);
            if (!hasErrors)
                setCSVFile(raw)
        }
    }

    const handleSubmitFile = async (e) => {
        setIsLoading(true)
        if (csvFile) {
            if (csvValidation.length == 0)
                try {
                    await service.UploadPositionsCSV(csvFile);
                    await handleTableLoad();
                } catch (e) {
                    console.warn(e);
                }
        }
        setIsLoading(false)
    }

    const handleCSVParsing = (data: any) => {

        let parsedData = [];

        // base64 -> UTF-8
        function b64DecodeUnicode(str) {
            return decodeURIComponent(Array.prototype.map.call(atob(str), function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            }).join(''))
        }

        // CSV parser
        Papa.parse(
            b64DecodeUnicode(data), {
            header: true,
            skipEmptyLines: true,
            delimiter: ";",
            complete: (result) => {
                parsedData = result.data;
            },
            fail: (error) => {
                console.warn(error);
                parsedData = [];
            }
        })

        return parsedData;
    }

    const handleCSVValidation = (data: any) => {
         
        setCSVValidation([]);
        let validations: string[] = [];

        let headers = Object.keys(data[0] ?? []);

        if (headers.length == 0)
            validations.push("Cabeçalho não encontrado.")

        headers.length > 0 && headers.forEach((h) => {
            if (!tableHeaders.includes(h))
                validations.push(`Coluna "${h}" inválida, verifique o arquivo!`);
        })

        if (validations.length > 0) {
            setHasErrors(true);
            setCSVValidation(validations);
        } else {
            setHasErrors(false);
        }
    }

    const handleTableLoad = () => {
        setIsLoading(true);
        user && service.GetPositionsCSV()
            .then(response => {console.log(response); setPivotTableData(response.data)})
            .catch(error => console.debug(error))
            .then(() => setIsLoading(false))
    }
 
    useEffect(handleTableLoad, [user.ClientGroupSelected])

    const dashboardCards = [
        {
            type: "Custom",
            position: {
                RowSpan: 1,
                ColSpan: 12, row: 1, col: 1 },
        
            customContentRender: () =>
                <PivotTableWebix style={{ height: 'calc(100vh - 175px)' }} idView={'positions'} key={'positions'} data={pivotTableData} fields={tableFields} structure={tableStructure} />,
            title: () => "Tabela",
        }
    ]
    const monthOpt = [
        {
            label: 'Janeiro',
            value: 1
        },
        {
            label: 'Favereiro',
            value: 2
        },
        {
            label: 'Março',
            value: 3
        },
        {
            label: 'Abril',
            value: 4
        },
        {
            label: 'Maio',
            value: 5
        },
        {
            label: "Junho",
            value: 6
        },
        {
            label: "Julho",
            value: 7
        },
        {
            label: "Agosto",
            value: 8
        },
        {
            label: "Setembro",
            value: 9
        },
        {
            label: "Outubro",
            value: 10
        },
        {
            label: "Novembro",
            value: 11
        },
        {
            label: "Dezembro",
            value: 12
        }
    ];

    const countryOpt = [
        {
            label: 'Afeganistão',
            value: 'AF'
        },
        {
            label: 'África do Sul',
            value: 'ZA'
        },
        {
            label: 'Albânia',
            value: 'AL'
        },
        {
            label: 'Alemanha',
            value: 'DE'
        },
        {
            label: 'Andorra',
            value: 'AD'
        },
        {
            label: 'Angola',
            value: 'AO'
        },
        {
            label: 'Anguila',
            value: 'AI'
        },
        {
            label: 'Antártica',
            value: 'AQ'
        },
        {
            label: 'Antígua e Barbuda',
            value: 'AG'
        },
        {
            label: 'Arábia Saudita',
            value: 'SA'
        },
        {
            label: 'Argélia',
            value: 'DZ'
        },
        {
            label: 'Argentina',
            value: 'AR'
        },
        {
            label: 'Armênia',
            value: 'AM'
        },
        {
            label: 'Aruba',
            value: 'AW'
        },
        {
            label: 'Austrália',
            value: 'AU'
        },
        {
            label: 'Áustria',
            value: 'AT'
        },
        {
            label: 'Azerbaijão',
            value: 'AZ'
        },
        {
            label: 'Bahamas',
            value: 'BS'
        },
        {
            label: 'Bahrein',
            value: 'BH'
        },
        {
            label: 'Bangladesh',
            value: 'BD'
        },
        {
            label: 'Barbados',
            value: 'BB'
        },
        {
            label: 'Belarus',
            value: 'BY'
        },
        {
            label: 'Bélgica',
            value: 'BE'
        },
        {
            label: 'Belize',
            value: 'BZ'
        },
        {
            label: 'Benin',
            value: 'BJ'
        },
        {
            label: 'Bermudas',
            value: 'BM'
        },
        {
            label: 'Bolívia',
            value: 'BO'
        },
        {
            label: 'Bósnia e Herzegovina',
            value: 'BA'
        },
        {
            label: 'Botsuana',
            value: 'BW'
        },
        {
            label: 'Brasil',
            value: 'BR'
        },
        {
            label: 'Brunei',
            value: 'BN'
        },
        {
            label: 'Bulgária',
            value: 'BG'
        },
        {
            label: 'Burkina Faso',
            value: 'BF'
        },
        {
            label: 'Burundi',
            value: 'BI'
        },
        {
            label: 'Butão',
            value: 'BT'
        },
        {
            label: 'Cabo Verde',
            value: 'CV'
        },
        {
            label: 'Camarões',
            value: 'CM'
        },
        {
            label: 'Camboja',
            value: 'KH'
        },
        {
            label: 'Canadá',
            value: 'CA'
        },
        {
            label: 'Cazaquistão',
            value: 'KZ'
        },
        {
            label: 'Chade',
            value: 'TD'
        },
        {
            label: 'Chile',
            value: 'CL'
        },
        {
            label: 'China',
            value: 'CN'
        },
        {
            label: 'Chipre',
            value: 'CY'
        },
        {
            label: 'Cingapura',
            value: 'SG'
        },
        {
            label: 'Colômbia',
            value: 'CO'
        },
        {
            label: 'Comores',
            value: 'KM'
        },
        {
            label: 'Coréia do Norte',
            value: 'KP'
        },
        {
            label: 'Coréia do Sul',
            value: 'KR'
        },
        {
            label: 'Costa do Marfim',
            value: 'CI'
        },
        {
            label: 'Costa Rica',
            value: 'CR'
        },
        {
            label: 'Croácia',
            value: 'HR'
        },
        {
            label: 'Cuba',
            value: 'CU'
        },
        {
            label: 'Curaçao',
            value: 'CW'
        },
        {
            label: 'Dinamarca',
            value: 'DK'
        },
        {
            label: 'Djibouti',
            value: 'DJ'
        },
        {
            label: 'Dominica',
            value: 'DM'
        },
        {
            label: 'Egito',
            value: 'EG'
        },
        {
            label: 'El Salvador',
            value: 'SV'
        },
        {
            label: 'Emirados Árabes Unidos',
            value: 'AE'
        },
        {
            label: 'Equador',
            value: 'EC'
        },
        {
            label: 'Eritreia',
            value: 'ER'
        },
        {
            label: 'Eslováquia',
            value: 'SK'
        },
        {
            label: 'Eslovênia',
            value: 'SI'
        },
        {
            label: 'Espanha',
            value: 'ES'
        },
        {
            label: 'Estados Federados da Micronésia',
            value: 'FM'
        },
        {
            label: 'Estados Unidos da América',
            value: 'US'
        },
        {
            label: 'Estônia',
            value: 'EE'
        },
        {
            label: 'Eswatini',
            value: 'SZ'
        },
        {
            label: 'Etiópia',
            value: 'ET'
        },
        {
            label: 'Fiji',
            value: 'FJ'
        },
        {
            label: 'Filipinas',
            value: 'PH'
        },
        {
            label: 'Finlândia',
            value: 'FI'
        },
        {
            label: 'França',
            value: 'FR'
        },
        {
            label: 'Gabão',
            value: 'GA'
        },
        {
            label: 'Gâmbia',
            value: 'GM'
        },
        {
            label: 'Gana',
            value: 'GH'
        },
        {
            label: 'Geórgia',
            value: 'GE'
        },
        {
            label: 'Geórgia do Sul e as Ilhas Sandwich do Sul',
            value: 'GS'
        },
        {
            label: 'Gibraltar',
            value: 'GI'
        },
        {
            label: 'Grécia',
            value: 'GR'
        },
        {
            label: 'Grenada',
            value: 'GD'
        },
        {
            label: 'Gronelândia',
            value: 'GL'
        },
        {
            label: 'Guadalupe',
            value: 'GP'
        },
        {
            label: 'Guam',
            value: 'GU'
        },
        {
            label: 'Guatemala',
            value: 'GT'
        },
        {
            label: 'Guernsey',
            value: 'GG'
        },
        {
            label: 'Guiana',
            value: 'GY'
        },
        {
            label: 'Guiana Francesa',
            value: 'GF'
        },
        {
            label: 'Guiné',
            value: 'GN'
        },
        {
            label: 'Guiné Equatorial',
            value: 'GQ'
        },
        {
            label: 'Guiné-Bissau',
            value: 'GW'
        },
        {
            label: 'Haiti',
            value: 'HT'
        },
        {
            label: 'Honduras',
            value: 'HN'
        },
        {
            label: 'Hong Kong',
            value: 'HK'
        },
        {
            label: 'Hungria',
            value: 'HU'
        },
        {
            label: 'Iêmen',
            value: 'YE'
        },
        {
            label: 'Ilha Bouvet',
            value: 'BV'
        },
        {
            label: 'Ilha da Reunião',
            value: 'RE'
        },
        {
            label: 'Ilha de Man',
            value: 'IM'
        },
        {
            label: 'Ilha de Natal',
            value: 'CX'
        },
        {
            label: 'Ilha Norfolk',
            value: 'NF'
        },
        {
            label: 'Ilhas Åland',
            value: 'AX'
        },
        {
            label: 'Ilhas Cayman',
            value: 'KY'
        },
        {
            label: 'Ilhas Cocos',
            value: 'CC'
        },
        {
            label: 'Ilhas Cook',
            value: 'CK'
        },
        {
            label: 'Ilhas Faroe',
            value: 'FO'
        },
        {
            label: 'Ilhas Malvinas',
            value: 'FK'
        },
        {
            label: 'Ilhas Marianas do Norte',
            value: 'MP'
        },
        {
            label: 'Ilhas Marshall',
            value: 'MH'
        },
        {
            label: 'Ilhas Menores Distantes dos Estados Unidos',
            value: 'UM'
        },
        {
            label: 'Ilhas Pitcairn',
            value: 'PN'
        },
        {
            label: 'Ilhas Salomão',
            value: 'SB'
        },
        {
            label: 'Ilhas Turcas e Caicos',
            value: 'TC'
        },
        {
            label: 'Ilhas Virgens (Reino Unido)',
            value: 'VG'
        },
        {
            label: 'Ilhas Virgens dos Estados Unidos',
            value: 'VI'
        },
        {
            label: 'Índia',
            value: 'IN'
        },
        {
            label: 'Indonésia',
            value: 'ID'
        },
        {
            label: 'Irã	',
            value: 'IR'
        },
        {
            label: 'Iraque',
            value: 'IQ'
        },
        {
            label: 'Irlanda',
            value: 'IE'
        },
        {
            label: 'Islândia',
            value: 'IS'
        },
        {
            label: 'Israel',
            value: 'IL'
        },
        {
            label: 'Itália',
            value: 'IT'
        },
        {
            label: 'Jamaica',
            value: 'JM'
        },
        {
            label: 'Japão',
            value: 'JP'
        },
        {
            label: 'Jersey',
            value: 'JE'
        },
        {
            label: 'Jordânia',
            value: 'JO'
        },
        {
            label: 'Kiribati',
            value: 'KI'
        },
        {
            label: 'Kosovo',
            value: 'XK'
        },
        {
            label: 'Kuwait',
            value: 'KW'
        },
        {
            label: 'Laos',
            value: 'LA'
        },
        {
            label: 'Lesotho',
            value: 'LS'
        },
        {
            label: 'Letônia',
            value: 'LV'
        },
        {
            label: 'Líbano',
            value: 'LB'
        },
        {
            label: 'Libéria',
            value: 'LR'
        },
        {
            label: 'Líbia',
            value: 'LY'
        },
        {
            label: 'Liechtenstein',
            value: 'LI'
        },
        {
            label: 'Lituânia',
            value: 'LT'
        },
        {
            label: 'Luxemburgo',
            value: 'LU'
        },
        {
            label: 'Macau',
            value: 'MO'
        },
        {
            label: 'Madagascar',
            value: 'MG'
        },
        {
            label: 'Malásia',
            value: 'MY'
        },
        {
            label: 'Malauí',
            value: 'MW'
        },
        {
            label: 'Maldivas',
            value: 'MV'
        },
        {
            label: 'Mali',
            value: 'ML'
        },
        {
            label: 'Malta',
            value: 'MT'
        },
        {
            label: 'Marrocos',
            value: 'MA'
        },
        {
            label: 'Martinica',
            value: 'MQ'
        },
        {
            label: 'Maurício',
            value: 'MU'
        },
        {
            label: 'Mauritânia',
            value: 'MR'
        },
        {
            label: 'Mayotte',
            value: 'YT'
        },
        {
            label: 'México',
            value: 'MX'
        },
        {
            label: 'Mianmar',
            value: 'MM'
        },
        {
            label: 'Vaticano',
            value: 'VA'
        },
        {
            label: 'Moçambique',
            value: 'MZ'
        },
        {
            label: 'Moldávia',
            value: 'MD'
        },
        {
            label: 'Mongólia',
            value: 'MN'
        },
        {
            label: 'Montenegro',
            value: 'ME'
        },
        {
            label: 'Montserrat',
            value: 'MS'
        },
        {
            label: 'Namíbia',
            value: 'NA'
        },
        {
            label: 'Nauru',
            value: 'NR'
        },
        {
            label: 'Nepal',
            value: 'NP'
        },
        {
            label: 'Nicarágua',
            value: 'NI'
        },
        {
            label: 'Níger',
            value: 'NE'
        },
        {
            label: 'Nigéria',
            value: 'NG'
        },
        {
            label: 'Niue',
            value: 'NU'
        },
        {
            label: 'Norte da Macedônia',
            value: 'MK'
        },
        {
            label: 'Noruega',
            value: 'NO'
        },
        {
            label: 'Nova Caledônia',
            value: 'NC'
        },
        {
            label: 'Nova Zelândia',
            value: 'NZ'
        },
        {
            label: 'Omã',
            value: 'OM'
        },
        {
            label: 'Ouvido e Ilhas McDonald	',
            value: 'HM'
        },
        {
            label: 'Países Baixos',
            value: 'NL'
        },
        {
            label: 'Países Baixos Caribenhos',
            value: 'BQ'
        },
        {
            label: 'Palau',
            value: 'PW'
        },
        {
            label: 'Palestina',
            value: 'PS'
        },
        {
            label: 'Panamá',
            value: 'PA'
        },
        {
            label: 'Papua Nova Guiné',
            value: 'PG'
        },
        {
            label: 'Paquistão',
            value: 'PK'
        },
        {
            label: 'Paraguai',
            value: 'PY'
        },
        {
            label: 'Peru',
            value: 'PE'
        },
        {
            label: 'Polinésia Francesa',
            value: 'PF'
        },
        {
            label: 'Polônia',
            value: 'PL'
        },
        {
            label: 'Porto Rico',
            value: 'PR'
        },
        {
            label: 'Portugal',
            value: 'PT'
        },
        {
            label: 'Principado de Mônaco',
            value: 'MC'
        },
        {
            label: 'Qatar',
            value: 'QA'
        },
        {
            label: 'Quênia',
            value: 'KE'
        },
        {
            label: 'Quirguizistão',
            value: 'KG'
        },
        {
            label: 'Reino Unido',
            value: 'GB'
        },
        {
            label: 'República Centro-Africana',
            value: 'CF'
        },
        {
            label: 'República Democrática do Congo',
            value: 'CD'
        },
        {
            label: 'República do Congo',
            value: 'CG'
        },
        {
            label: 'República Dominicana',
            value: 'DO'
        },
        {
            label: 'Romênia',
            value: 'RO'
        },
        {
            label: 'Ruanda',
            value: 'RW'
        },
        {
            label: 'Rússia',
            value: 'RU'
        },
        {
            label: 'Saara Ocidental',
            value: 'EH'
        },
        {
            label: 'Samoa',
            value: 'WS'
        },
        {
            label: 'Samoa Americana',
            value: 'AS'
        },
        {
            label: 'Santa Helena, Ascensão e Tristão da Cunha',
            value: 'SH'
        },
        {
            label: 'Santa Lúcia',
            value: 'LC'
        },
        {
            label: 'Santo Bartolomeu',
            value: 'BL'
        },
        {
            label: 'São Marino',
            value: 'SM'
        },
        {
            label: 'São Martinho',
            value: 'MF'
        },
        {
            label: 'São Pedro e Miquelon',
            value: 'PM'
        },
        {
            label: 'São Tomé e Príncipe',
            value: 'ST'
        },
        {
            label: 'São Vicente e as Granadinas',
            value: 'VC'
        },
        {
            label: 'Senegal',
            value: 'SN'
        },
        {
            label: 'Serra Leoa',
            value: 'SL'
        },
        {
            label: 'Sérvia',
            value: 'RS'
        },
        {
            label: 'Seychelles',
            value: 'SC'
        },
        {
            label: 'Sint Maarten',
            value: 'SX'
        },
        {
            label: 'Síria',
            value: 'SY'
        },
        {
            label: 'Somália',
            value: 'SO'
        },
        {
            label: 'Sri Lanka',
            value: 'LK'
        },
        {
            label: 'St. Kitts e Nevis',
            value: 'KN'
        },
        {
            label: 'Sudão',
            value: 'SD'
        },
        {
            label: 'Sudão do Sul',
            value: 'SS'
        },
        {
            label: 'Suécia',
            value: 'SE'
        },
        {
            label: 'Suíça',
            value: 'CH'
        },
        {
            label: 'Suriname',
            value: 'SR'
        },
        {
            label: 'Svalbard e Jan Mayen',
            value: 'SJ'
        },
        {
            label: 'Tailândia',
            value: 'TH'
        },
        {
            label: 'Taiwan',
            value: 'TW'
        },
        {
            label: 'Tajiquistão',
            value: 'TJ'
        },
        {
            label: 'Tanzânia',
            value: 'TZ'
        },
        {
            label: 'Tcheca',
            value: 'CZ'
        },
        {
            label: 'Território Britânico do Oceano Índico',
            value: 'IO'
        },
        {
            label: 'Territórios Franceses do Sul e Antártico',
            value: 'TF'
        },
        {
            label: 'Timor Leste',
            value: 'TL'
        },
        {
            label: 'Togo',
            value: 'TG'
        },
        {
            label: 'Tokelau',
            value: 'TK'
        },
        {
            label: 'Tonga',
            value: 'TO'
        },
        {
            label: 'Trinidad e Tobago',
            value: 'TT'
        },
        {
            label: 'Tunísia',
            value: 'TN'
        },
        {
            label: 'Turcomenistão',
            value: 'TM'
        },
        {
            label: 'Turquia',
            value: 'TR'
        },
        {
            label: 'Tuvalu',
            value: 'TV'
        },
        {
            label: 'Ucrânia',
            value: 'UA'
        },
        {
            label: 'Uganda',
            value: 'UG'
        },
        {
            label: 'Uruguai',
            value: 'UY'
        },
        {
            label: 'Uzbequistão',
            value: 'UZ'
        },
        {
            label: 'Vanuatu',
            value: 'VU'
        },
        {
            label: 'Vaticano',
            value: 'VA'
        },
        {
            label: 'Venezuela',
            value: 'VE'
        },
        {
            label: 'Vietnã',
            value: 'VN'
        },
        {
            label: 'Wallis e Futuna',
            value: 'WF'
        },
        {
            label: 'Zâmbia',
            value: 'ZM'
        },
        {
            label: 'Zimbábue',
            value: 'ZW'
        },
        
    ];

    const criarArrayDeAnos = (anoInicial: number): { label: string, value: number }[] => {
        const anoAtual = new Date().getFullYear();
        const anos = new Array<{ label: string, value: number }>(anoAtual - anoInicial + 1);
      
        for (let ano = anoAtual, i = 0; ano >= anoInicial; ano--, i++) {
          anos[i] = { label: ano.toString(), value: ano };
        }
      
        return anos;
      }
      
    const yearOpt = criarArrayDeAnos(2015);

    const layoutButtons = [
        {
            icon: "ppi ppi-upload",
            tooltip: "Upload CSV",
            onClick: () => setShowSidePanel(!showSidePanel)
        },
        {
            icon: "ppi ppi-user",
            tooltip: "Atualizar QL",
            onClick: () => setSideModalVisibleQL(!showSidePanel)
        },
        {
            icon: "ppi ppi-currency-dollar",
            tooltip: "Atualizar Orçado",
            onClick: () => setSideModalVisible(!showSidePanel)
        }
    ]
  
    const [loadingForm, setLoadingForm] = useState<boolean>(false); 
    const [sideModalVisible, setSideModalVisible] = useState<boolean>(false);
    const [loadingFormQL, setLoadingFormQL] = useState<boolean>(false); 
    const [sideModalVisibleQL, setSideModalVisibleQL] = useState<boolean>(false); 
    const [countryOrcado, setCountryOrcado] = useState<any | undefined>();
    const [monthOrcado, setMonthOrcado] = useState<any | undefined>();
    const [yearOrcado, setYearOrcado] = useState<any | undefined>();
    const [valueOrcado, setValueOrcado] = useState<any | undefined>();
    const [countryQL, setCountryQL] = useState<any | undefined>();
    const [monthQL, setMonthQL] = useState<any | undefined>();
    const [yearQL, setYearQL] = useState<any | undefined>();
    const [valueQL, setValueQL] = useState<any | undefined>(); 

    const sideModalOnClose = () => { 
        setSideModalVisibleQL(false);
        setSideModalVisible(false);
        setShowSidePanel(false);
    }

    const UpdateRecordOrcado = () => {
        setLoadingForm(true);
        try {
            let OrcadoToSave = {
                value: valueOrcado,
                country: countryOrcado,
                month: monthOrcado,
                year: yearOrcado,
            };

            service.UpdateOrcado(OrcadoToSave)
                .then(result => {
                    setLoadingForm(false);
                    enqueueSnackbar(`Registro atualizado com sucesso`, {
                        variant: 'success',
                        preventDuplicate: true,
                        persist: false,
                    })
                })
                .catch(err => {
                    enqueueSnackbar(`Erro ao atualizar registro`, {
                        variant: 'warning',
                        preventDuplicate: true,
                        persist: false,
                    })
                    console.log(err);
                })
                .then(() => {
                    setLoadingForm(false);
                    sideModalOnClose()
                })
        } catch (e) {
            setLoadingForm(false);
        }
        setSideModalVisibleQL(false);
        setSideModalVisible(false);
        setShowSidePanel(false);
    }

    const UpdateRecordQL = () => {
        setLoadingFormQL(true);
        try {
            let QLToSave = {
                value: valueQL,
                country: countryQL,
                month: monthQL,
                year: yearQL,
            };

            service.UpdateQL(QLToSave)
                .then(result => {
                    setLoadingForm(false);
                    enqueueSnackbar(`Registro atualizado com sucesso`, {
                        variant: 'success',
                        preventDuplicate: true,
                        persist: false,
                    })
                })
                .catch(err => {
                    enqueueSnackbar(`Erro ao atualizar registro`, {
                        variant: 'warning',
                        preventDuplicate: true,
                        persist: false,
                    })
                    console.log(err);
                })
                .then(() => {
                    setLoadingFormQL(false);
                    sideModalOnClose()
                })
        } catch (e) {
            setLoadingFormQL(false);
        }
       
    }

    return (
        <Layout functionsGeneric={layoutButtons}>
            <LcLoading loading={isLoading}>
                <LCDashboard cards={dashboardCards}   />
            </LcLoading>
            <SideModal header={"Upload CSV"} visible={showSidePanel} onClose={sideModalOnClose}>
                <div className="form">
                    <PPInputFile
                        title="Selecione ou arraste para a tela, um arquivo *.csv válido."
                        acceptedTypes={["text/csv"]}
                        onChange={handleChangeFile}
                        maxSize={2097152}
                        multiple={false}
                    />
                    <div className="functions">
                        <button className="lc-button bg-info" onClick={handleSubmitFile} disabled={hasErrors}>Enviar</button>
                    </div>
                    <div className="validationMessages">
                        {
                            csvValidation.length > 0 &&
                            <ul>
                                {
                                    csvValidation.map(msg => <li><span style={{ color: "red" }}>{msg}</span></li>)
                                }
                            </ul>
                        }
                    </div>
                </div> 
            </SideModal>
            <SideModal header={"Atualizar Orçado"} visible={sideModalVisible} onClose={sideModalOnClose}>
                <div className="lc-segment bg-info">
                    Alterações poderão gerar distorções nos relatórios e orçamentos.
                </div>
                <div className="form">
                    <LcLoading loading={loadingForm} label="Salvando registro...">
                        <PPDropDown title="Pais" onChange={event => { setCountryOrcado(event.value); }} options={countryOpt} />
                        <PPDropDown name='MesOrcado' title="Mes" onChange={event => setMonthOrcado(event.value)} options={monthOpt}/>
                        <PPDropDown name='YearOrcado' title="Ano"   onChange={event => setYearOrcado(event.value)} options={yearOpt}/>
                        <PPInput name='valueOrcado' title="Valor monetário" type="number" value={valueOrcado} onChange={event => setValueOrcado(event.target.value)} />

                        <div className="commands">
                            <button className="lc-button bg-primary" onClick={UpdateRecordOrcado}>Salvar</button>
                            <button className="lc-button bg-grey" onClick={sideModalOnClose}>Cancelar</button>
                        </div>
                    </LcLoading>
                </div>

            </SideModal>
            <SideModal header={"Atualizar QL"} visible={sideModalVisibleQL} onClose={sideModalOnClose}>
                <div className="lc-segment bg-info">
                    Alterações poderão gerar distorções nos relatórios e orçamentos.
                </div>
                <div className="form">
                    <LcLoading loading={loadingFormQL} label="Salvando registro...">
                        <PPDropDown title="Pais"  onChange={event => { setCountryQL(event.value); } } options={countryOpt} />
                        <PPDropDown name='MesQL' title="Mes" onChange={event => setMonthQL(event.value)} options={monthOpt} />
                        <PPDropDown name='YearQL' title="Ano"  onChange={event => setYearQL(event.value)} options={yearOpt} />
                        <PPInput name='valueQL' title="Quantidade" type="number" value={valueQL} onChange={event => setValueQL(event.target.value)} />

                        <div className="commands">
                            <button className="lc-button bg-primary" onClick={UpdateRecordQL}>Salvar</button>
                            <button className="lc-button bg-grey" onClick={sideModalOnClose}>Cancelar</button>
                        </div>
                    </LcLoading>
                </div>

            </SideModal>
        </Layout>
    )

}

export default PositionsTable

